<div class="page-container for_contact" style="background-image: url(./assets/img/tempnavmotif_top.svg);">
	<h1>
		Contact us
	</h1>
	<div class="conatct_page_cont">
		<form class="form_cont" [formGroup]="contactForm" autocomplete="off">

			<div class="form_row fhr">
				<div class="form_row_inner">
					<span class="side_label">
						<span class="material-symbols-outlined">person</span> *
					</span>
					<input matInput
						   type="text"
						   placeholder="Name"
						   formControlName="name" required>
					<ng-container *ngIf="hasError('name')">
						<mat-error class="error_input" *ngIf="form.name.hasError('required')">Name is required</mat-error>
					</ng-container>
				</div>
				<div class="form_row_inner">
					<span class="side_label">
						<span class="material-symbols-outlined">mail</span> *
					</span>
					<input matInput
						   type="text"
						   placeholder="E-mail"
						   formControlName="email" required>
					<ng-container *ngIf="hasError('email')">
						<mat-error class="error_input" *ngIf="form.email.hasError('required')">Email is required</mat-error>
						<mat-error class="error_input" *ngIf="form.email.hasError('email')">Invalid email format</mat-error>
					</ng-container>
				</div>
			</div>

			<div class="form_row fr">
				<div class="form_row_inner">
					<span class="side_label">
						<span class="material-symbols-outlined">inventory_2</span>
					</span>
					<input matInput
						   type="text"
						   placeholder="Product Type (Fabrics, Apparels, Accessories)"
						   formControlName="productType">
				</div>
			</div>

			<div class="form_row fr">
				<div class="form_row_inner">
					<textarea placeholder="Product Description (Please share any customization required)"
							  formControlName="productDescription"></textarea>
				</div>
			</div>

			<div class="form_row fhr">
				<div class="form_row_inner">
					<span class="side_label">
						<span class="material-symbols-outlined">
							weight
						</span>
					</span>
					<input matInput type="number" placeholder="Quantity required" formControlName="quantity">
				</div>
				<div class="form_row_inner">
					<span class="side_label">
						<span class="material-symbols-outlined">
							calendar_month
						</span>
					</span>
					<input type="date" placeholder="Required delivery date" formControlName="deliveryDate">
				</div>
			</div>

			<div *ngIf="isBrowser" class="dropzone">
				<ngx-dropzone style="border:1px solid #b7a88e" (change)="onSelect($event)"
							  accept="image/jpeg,image/jpg,image/png,image/svg,image/webp" class="drop_zone_cont" #dropzone>
					<ngx-dropzone-label class="d_l">Attach image of the product</ngx-dropzone-label>

					<ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
												[removable]="true" (removed)="onRemove(f)">
						<ngx-dropzone-label class="image_label">{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
					</ngx-dropzone-image-preview>
				</ngx-dropzone>
				<button class="add_more_images_button" *ngIf="showAddImagesButton" (click)="dropzone.showFileSelector()">Add More images</button>
			</div>

			<div class="form_row fhr">
				<div class="form_row_inner">
					<span class="side_label">
						<span class="material-symbols-outlined">phone</span>*
					</span>
					<input matInput
						   type="text"
						   placeholder="Phone"
						   formControlName="phone"
						   required
						   (keypress)="matcher($event)">
					<ng-container *ngIf="hasError('phone')">
						<mat-error class="error_input" *ngIf="form.phone.hasError('required')">Phone number is required</mat-error>
						<mat-error class="error_input" *ngIf="form.phone.hasError('minlength')">Phone number should be more than 7 characters long</mat-error>
					</ng-container>
				</div>
				<div class="form_row_inner">
					<span class="side_label">
						<span class="material-symbols-outlined">globe_asia</span> *
					</span>
					<select formControlName="country">
						<option value="" class="defalut_option">Country</option>
						<option [value]="country.name" *ngFor="let country of countryList">{{ country.name }}</option>
					</select>
					<ng-container *ngIf="hasError('country')">
						<mat-error class="error_input" *ngIf="form.country.hasError('required')">Country is required</mat-error>
					</ng-container>
				</div>
			</div>

			<div class="form_row fhr">
				<div class="form_row_inner">
					<span class="side_label">
						<span class="material-symbols-outlined">
							apartment
						</span>
					</span>
					<input matInput
						   type="text"
						   placeholder="Company Name"
						   formControlName="company">
				</div>
				<div class="form_row_inner">
					<span class="side_label">
						<span class="material-symbols-outlined">
							web
						</span>
					</span>
					<input matInput
						   type="text"
						   placeholder="Company Website"
						   formControlName="companyWebsite">
				</div>
			</div>
		</form>
	</div>


	<ngx-recaptcha2 *ngIf="isBrowser" #captchaElem
					[siteKey]="siteKey"
					(success)="handleSuccess($event)"
					[useGlobalDomain]="false"
					class="captcha_cont">
	</ngx-recaptcha2>


	<button class="submit" (click)="submitForm()" type="submit" [disabled]="contactForm.invalid && isFormDisabled">
		Submit Request
	</button>

	<div class="loaction_cont">
		<div class="form_row fhr">
			<span class="material-symbols-outlined">
				location_on
			</span>
			<h3 class="width_full">West Bengal</h3>
			<p class="heading width_full">
				Anuprerna Artisan Aliance Pvt. Ltd.
			</p>
			<p class="width_full">
				Vill - Alipur P.O- Debipur(R.S)
				<br/>
				P.S Memari Dist - Burdwan (East)
				<br/>
				West Bengal
				<br/>
				India - 713146
				<br/>
				Contact - 8653403212
			</p>
		</div>
<!--		<div class="form_row fhr">-->
<!--			<span class="material-symbols-outlined">-->
<!--				lift_to_talk-->
<!--			</span>-->
<!--			<h3 class="width_full">BANGALORE</h3>-->
<!--			<p class="heading width_full">-->
<!--				Anuprerna Artisan Alliance Pvt. Ltd-->
<!--			</p>-->
<!--			<p class="width_full">-->
<!--				Kt-5, Kareem Tower,-->
<!--				<br/>-->
<!--				Cunninghum Road, 2nd floor,-->
<!--				<br/>-->
<!--				Vasanth Nagar.-->
<!--				<br/>-->
<!--				Bengaluru-->
<!--				<br/>-->
<!--				Karnataka 560051-->
<!--			</p>-->
<!--		</div>-->
	</div>
</div>
